import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=56de6d2e&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=56de6d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de6d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56de6d2e')) {
      api.createRecord('56de6d2e', component.options)
    } else {
      api.reload('56de6d2e', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=56de6d2e&scoped=true&", function () {
      api.rerender('56de6d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27UopW193o4ot/JS/comp/DateRange.vue"
export default component.exports